module.exports = __webpack_public_path__ + "static/media/ilkley-19.1f27e17b.jpg";